var items = {
  "block.minecraft.air": "luft",
  "block.minecraft.stone": "stoa",
  "block.minecraft.granite": "granit",
  "block.minecraft.polished_granite": "poliata granit",
  "block.minecraft.diorite": "diorit",
  "block.minecraft.polished_diorite": "poliata diorit",
  "block.minecraft.andesite": "andesit",
  "block.minecraft.polished_andesite": "poliata andesit",
  "block.minecraft.grass_block": "grosblock",
  "block.minecraft.dirt": "erdn",
  "block.minecraft.coarse_dirt": "grobe erdn",
  "block.minecraft.podzol": "podsol",
  "block.minecraft.crimson_nylium": "karmesin-nezel",
  "block.minecraft.warped_nylium": "wirr-nezl",
  "block.minecraft.cobblestone": "bruchstoa",
  "block.minecraft.oak_planks": "oachnhoizbrettl",
  "block.minecraft.spruce_planks": "fichtnhoizbrettl",
  "block.minecraft.birch_planks": "birknhoizbrettl",
  "block.minecraft.jungle_planks": "tropnhoizbrettl",
  "block.minecraft.acacia_planks": "akazienhoizbrettl",
  "block.minecraft.dark_oak_planks": "schworzoachnhoizbrettl",
  "block.minecraft.crimson_planks": "karmesinbrettl",
  "block.minecraft.warped_planks": "wirrbrettl",
  "block.minecraft.oak_sapling": "oachnsetzling",
  "block.minecraft.spruce_sapling": "fichtnsetzling",
  "block.minecraft.birch_sapling": "birknsetzling",
  "block.minecraft.jungle_sapling": "tropnbamsetzling",
  "block.minecraft.acacia_sapling": "akaziensetzling",
  "block.minecraft.dark_oak_sapling": "schworzoachnsetzling",
  "block.minecraft.bedrock": "grundstoa",
  "block.minecraft.sand": "sond",
  "block.minecraft.red_sand": "rota sond",
  "block.minecraft.gravel": "kies",
  "block.minecraft.gold_ore": "goiderz",
  "block.minecraft.iron_ore": "eisnerz",
  "block.minecraft.coal_ore": "stoakohle",
  "block.minecraft.nether_gold_ore": "nethergoiderz",
  "block.minecraft.oak_log": "oachnhoiz",
  "block.minecraft.spruce_log": "fichtnhoiz",
  "block.minecraft.birch_log": "birknhoiz",
  "block.minecraft.jungle_log": "tropnhoiz",
  "block.minecraft.acacia_log": "akazienhoiz",
  "block.minecraft.dark_oak_log": "schworzoachnhoiz",
  "block.minecraft.crimson_stem": "karmesinstomm",
  "block.minecraft.warped_stem": "wirrstomm",
  "block.minecraft.stripped_oak_log": "entrindets oachnhoiz",
  "block.minecraft.stripped_spruce_log": "entrindets fichtnhoiz",
  "block.minecraft.stripped_birch_log": "entrindets birknhoiz",
  "block.minecraft.stripped_jungle_log": "entrindets tropnhoiz",
  "block.minecraft.stripped_acacia_log": "entrindets akazienhoiz",
  "block.minecraft.stripped_dark_oak_log": "entrindets schworzoachnhoiz",
  "block.minecraft.stripped_crimson_stem": "gschöta karmesinstomm",
  "block.minecraft.stripped_warped_stem": "gschöta zerrstomm",
  "block.minecraft.stripped_oak_wood": "entrindetes schworzoichenholz",
  "block.minecraft.stripped_spruce_wood": "entrindets fichtnhoiz",
  "block.minecraft.stripped_birch_wood": "entrindets birknhoiz",
  "block.minecraft.stripped_jungle_wood": "entrindets tropnhoiz",
  "block.minecraft.stripped_acacia_wood": "entrindets akazienhoiz",
  "block.minecraft.stripped_dark_oak_wood": "entrindets schworzoachnhoiz",
  "block.minecraft.stripped_crimson_hyphae": "gschöta karmesinhyphn",
  "block.minecraft.stripped_warped_hyphae": "gschöta wirrhyphn",
  "block.minecraft.oak_wood": "oachnhoiz",
  "block.minecraft.spruce_wood": "fichtnhoiz",
  "block.minecraft.birch_wood": "birknhoiz",
  "block.minecraft.jungle_wood": "tropnhoiz",
  "block.minecraft.acacia_wood": "akazienhoiz",
  "block.minecraft.dark_oak_wood": "schworzoachnhoiz",
  "block.minecraft.crimson_hyphae": "karmesinhyphn",
  "block.minecraft.warped_hyphae": "wirrhyphn",
  "block.minecraft.oak_leaves": "oachnlab",
  "block.minecraft.spruce_leaves": "fichtnnodln",
  "block.minecraft.birch_leaves": "birknlab",
  "block.minecraft.jungle_leaves": "tropnbamlab",
  "block.minecraft.acacia_leaves": "akazienlab",
  "block.minecraft.dark_oak_leaves": "schworzoachnlab",
  "block.minecraft.sponge": "schwomm",
  "block.minecraft.wet_sponge": "nossa schwomm",
  "block.minecraft.glass": "glos",
  "block.minecraft.lapis_ore": "lapislazulierz",
  "block.minecraft.lapis_block": "lapislazuliblock",
  "block.minecraft.dispenser": "werfa",
  "block.minecraft.sandstone": "sondstoa",
  "block.minecraft.chiseled_sandstone": "gmoaßlta sondstoa",
  "block.minecraft.cut_sandstone": "gschnittena sondstoa",
  "block.minecraft.note_block": "notnblock",
  "block.minecraft.powered_rail": "ontriebsschiene",
  "block.minecraft.detector_rail": "sensorschiene",
  "block.minecraft.sticky_piston": "pickiga kolbn",
  "block.minecraft.cobweb": "spinnennetz",
  "block.minecraft.grass": "gros",
  "block.minecraft.fern": "farn",
  "block.minecraft.dead_bush": "austrockneta busch",
  "block.minecraft.seagrass": "seegros",
  "block.minecraft.sea_pickle": "meeresgurkn",
  "block.minecraft.piston": "kolbn",
  "block.minecraft.white_wool": "weiße woin",
  "block.minecraft.orange_wool": "orange woin",
  "block.minecraft.magenta_wool": "magentane woin",
  "block.minecraft.light_blue_wool": "hellblaue woin",
  "block.minecraft.yellow_wool": "gelbe woin",
  "block.minecraft.lime_wool": "hellgrüne woin",
  "block.minecraft.pink_wool": "rosane woin",
  "block.minecraft.gray_wool": "graue woin",
  "block.minecraft.light_gray_wool": "hellgraue woin",
  "block.minecraft.cyan_wool": "türkise woin",
  "block.minecraft.purple_wool": "lilane woin",
  "block.minecraft.blue_wool": "blaue woin",
  "block.minecraft.brown_wool": "braune woin",
  "block.minecraft.green_wool": "grüne woin",
  "block.minecraft.red_wool": "rote woin",
  "block.minecraft.black_wool": "schworze woin",
  "block.minecraft.dandelion": "löwnzohn",
  "block.minecraft.poppy": "mohn",
  "block.minecraft.blue_orchid": "blaue orchidee",
  "block.minecraft.allium": "sternlauch",
  "block.minecraft.azure_bluet": "porzellansternchen",
  "block.minecraft.red_tulip": "rote tulpn",
  "block.minecraft.orange_tulip": "orange tulpn",
  "block.minecraft.white_tulip": "weiße tulpn",
  "block.minecraft.pink_tulip": "rosane tulpn",
  "block.minecraft.oxeye_daisy": "margerite",
  "block.minecraft.cornflower": "kornblume",
  "block.minecraft.lily_of_the_valley": "maiglöckchen",
  "block.minecraft.wither_rose": "witherrosn",
  "block.minecraft.brown_mushroom": "brauna püz",
  "block.minecraft.red_mushroom": "rota püz",
  "block.minecraft.crimson_fungus": "karmesinpüz",
  "block.minecraft.warped_fungus": "wirrpüz",
  "block.minecraft.crimson_roots": "karmesinwurzln",
  "block.minecraft.warped_roots": "wirrwurzln",
  "block.minecraft.nether_sprouts": "nether-spross",
  "block.minecraft.weeping_vines": "trauerranken",
  "block.minecraft.twisting_vines": "zwirblrankn",
  "block.minecraft.sugar_cane": "zuggarohr",
  "block.minecraft.kelp": "seetong",
  "block.minecraft.bamboo": "bambus",
  "block.minecraft.gold_block": "goidblock",
  "block.minecraft.iron_block": "eisnblock",
  "block.minecraft.oak_slab": "oachnhoizstufn",
  "block.minecraft.spruce_slab": "fichtnhoizstufn",
  "block.minecraft.birch_slab": "birknhoizstufn",
  "block.minecraft.jungle_slab": "tropnhoizstufn",
  "block.minecraft.acacia_slab": "akazienhoizstufn",
  "block.minecraft.dark_oak_slab": "schworzoachnstufn",
  "block.minecraft.crimson_slab": "karmesinstufn",
  "block.minecraft.warped_slab": "zerrstufe",
  "block.minecraft.stone_slab": "stoastufn",
  "block.minecraft.smooth_stone_slab": "glotte stoastufn",
  "block.minecraft.sandstone_slab": "sondstoastufn",
  "block.minecraft.cut_sandstone_slab": "gschnittene sondstoastufn",
  "block.minecraft.petrified_oak_slab": "vasteinate oachnhoizstufn",
  "block.minecraft.cobblestone_slab": "bruchstoastufn",
  "block.minecraft.brick_slab": "ziaglstufn",
  "block.minecraft.stone_brick_slab": "stoaziaglstufn",
  "block.minecraft.nether_brick_slab": "netherziaglstufn",
  "block.minecraft.quartz_slab": "quarzstufn",
  "block.minecraft.red_sandstone_slab": "rote sondstoastufn",
  "block.minecraft.cut_red_sandstone_slab": "gschnittene rote sondstoastufn",
  "block.minecraft.purpur_slab": "purpurstufn",
  "block.minecraft.prismarine_slab": "prismarinstufn",
  "block.minecraft.prismarine_brick_slab": "prismarinziaglstufn",
  "block.minecraft.dark_prismarine_slab": "dunkle prismarinstufn",
  "block.minecraft.smooth_quartz": "glotter quarzblock",
  "block.minecraft.smooth_red_sandstone": "glotta rota sondstoa",
  "block.minecraft.smooth_sandstone": "glotta sondstoa",
  "block.minecraft.smooth_stone": "glotta stoa",
  "block.minecraft.bricks": "ziagl",
  "block.minecraft.tnt": "tnt",
  "block.minecraft.bookshelf": "biacharegal",
  "block.minecraft.mossy_cobblestone": "bemoosta bruchstoa",
  "block.minecraft.obsidian": "obsidian",
  "block.minecraft.torch": "fockl",
  "block.minecraft.end_rod": "endstob",
  "block.minecraft.chorus_plant": "choruspflonzn",
  "block.minecraft.chorus_flower": "chorusblütn",
  "block.minecraft.purpur_block": "purpurblock",
  "block.minecraft.purpur_pillar": "purpursäule",
  "block.minecraft.purpur_stairs": "purpurtreppn",
  "block.minecraft.spawner": "spawner",
  "block.minecraft.oak_stairs": "oachnhoiztreppn",
  "block.minecraft.chest": "kistn",
  "block.minecraft.diamond_ore": "diamanterz",
  "block.minecraft.diamond_block": "diamantblock",
  "block.minecraft.crafting_table": "werkbonk",
  "block.minecraft.farmland": "ocka",
  "block.minecraft.furnace": "ofn",
  "block.minecraft.ladder": "leita",
  "block.minecraft.rail": "schiene",
  "block.minecraft.cobblestone_stairs": "bruchstoatreppn",
  "block.minecraft.lever": "schoita",
  "block.minecraft.stone_pressure_plate": "stoadruckplottn",
  "block.minecraft.oak_pressure_plate": "oachnhoizdruckplottn",
  "block.minecraft.spruce_pressure_plate": "fichtnhoizdruckplottn",
  "block.minecraft.birch_pressure_plate": "birknhoizdruckplottn",
  "block.minecraft.jungle_pressure_plate": "tropnhoizdruckplottn",
  "block.minecraft.acacia_pressure_plate": "akazeinhoizdruckplottn",
  "block.minecraft.dark_oak_pressure_plate": "schworzoachndruckplottn",
  "block.minecraft.crimson_pressure_plate": "karmesindruckplottn",
  "block.minecraft.warped_pressure_plate": "wirrdruckplottn",
  "block.minecraft.polished_blackstone_pressure_plate": "poliate schworzstoadruckplottn",
  "block.minecraft.redstone_ore": "redstoneerz",
  "block.minecraft.redstone_torch": "redstone-fockl",
  "block.minecraft.snow": "schnee",
  "block.minecraft.ice": "eis",
  "block.minecraft.snow_block": "schneeblock",
  "block.minecraft.cactus": "kaktus",
  "block.minecraft.clay": "ton",
  "block.minecraft.jukebox": "plottnspiela",
  "block.minecraft.oak_fence": "oachnhoizzaun",
  "block.minecraft.spruce_fence": "fichtnhoizzaun",
  "block.minecraft.birch_fence": "birknhoizzaun",
  "block.minecraft.jungle_fence": "tropnhoizzaun",
  "block.minecraft.acacia_fence": "akazienhoizzaun",
  "block.minecraft.dark_oak_fence": "schworzoachnhoizzaun",
  "block.minecraft.crimson_fence": "karmesinzaun",
  "block.minecraft.warped_fence": "wirrzaun",
  "block.minecraft.pumpkin": "kürbis",
  "block.minecraft.carved_pumpkin": "gschnitzta kürbis",
  "block.minecraft.netherrack": "netherrack",
  "block.minecraft.soul_sand": "seelnsond",
  "block.minecraft.soul_soil": "seelenerde",
  "block.minecraft.basalt": "basalt",
  "block.minecraft.polished_basalt": "polierter basalt",
  "block.minecraft.soul_torch": "seelenfockl",
  "block.minecraft.glowstone": "glowstone",
  "block.minecraft.jack_o_lantern": "kürbislatern",
  "block.minecraft.oak_trapdoor": "oachnhoizfoitir",
  "block.minecraft.spruce_trapdoor": "fichtnhoizfoitir",
  "block.minecraft.birch_trapdoor": "birknhoizfoitir",
  "block.minecraft.jungle_trapdoor": "tropnhoizfoitir",
  "block.minecraft.acacia_trapdoor": "akazienhoizfoitir",
  "block.minecraft.dark_oak_trapdoor": "schworzoachnhoizfoitir",
  "block.minecraft.crimson_trapdoor": "karmesinfoitir",
  "block.minecraft.warped_trapdoor": "wirrfoitir",
  "block.minecraft.infested_stone": "befoiena stoa",
  "block.minecraft.infested_cobblestone": "befoiena bruchstoa",
  "block.minecraft.infested_stone_bricks": "befoiene stoaziagl",
  "block.minecraft.infested_mossy_stone_bricks": "befoiene bemooste stoaziagl",
  "block.minecraft.infested_cracked_stone_bricks": "befoiene rissige stoaziagl",
  "block.minecraft.infested_chiseled_stone_bricks": "befoiene gmoaßlte stoaziagl",
  "block.minecraft.stone_bricks": "stoaziagl",
  "block.minecraft.mossy_stone_bricks": "bemooste stoaziagl",
  "block.minecraft.cracked_stone_bricks": "rissige stoaziagl",
  "block.minecraft.chiseled_stone_bricks": "gmoaßlte stoaziagl",
  "block.minecraft.brown_mushroom_block": "brauna püzblock",
  "block.minecraft.red_mushroom_block": "rota püzblock",
  "block.minecraft.mushroom_stem": "püzstengl",
  "block.minecraft.iron_bars": "eisngitta",
  "block.minecraft.chain": "kettn",
  "block.minecraft.glass_pane": "glosscheibn",
  "block.minecraft.melon": "melone",
  "block.minecraft.vine": "lianen",
  "block.minecraft.oak_fence_gate": "oachnhoizzauntor",
  "block.minecraft.spruce_fence_gate": "fichtnhoizzauntor",
  "block.minecraft.birch_fence_gate": "birknhoizzauntor",
  "block.minecraft.jungle_fence_gate": "tropnhoizzauntor",
  "block.minecraft.acacia_fence_gate": "akazienhoizzauntor",
  "block.minecraft.dark_oak_fence_gate": "schworzoachnhoizzauntor",
  "block.minecraft.crimson_fence_gate": "karmesinzauntor",
  "block.minecraft.warped_fence_gate": "wirrzauntor",
  "block.minecraft.brick_stairs": "ziagltreppn",
  "block.minecraft.stone_brick_stairs": "stoaziagltreppn",
  "block.minecraft.mycelium": "myzel",
  "block.minecraft.lily_pad": "seerosn",
  "block.minecraft.nether_bricks": "netherziagl",
  "block.minecraft.cracked_nether_bricks": "rissige netherziagl",
  "block.minecraft.chiseled_nether_bricks": "gmoaßlte netherziagl",
  "block.minecraft.nether_brick_fence": "netherziaglzaun",
  "block.minecraft.nether_brick_stairs": "netherziagltreppn",
  "block.minecraft.enchanting_table": "zaubatisch",
  "block.minecraft.end_portal_frame": "endportalrohmen",
  "block.minecraft.end_stone": "endstoa",
  "block.minecraft.end_stone_bricks": "endstoaziagl",
  "block.minecraft.dragon_egg": "drochnei",
  "block.minecraft.redstone_lamp": "redstone-lompn",
  "block.minecraft.sandstone_stairs": "sondstoatreppn",
  "block.minecraft.emerald_ore": "smaragderz",
  "block.minecraft.ender_chest": "enderkistn",
  "block.minecraft.tripwire_hook": "hokn",
  "block.minecraft.emerald_block": "smaragdblock",
  "block.minecraft.spruce_stairs": "fichtnhoiztreppn",
  "block.minecraft.birch_stairs": "birknhoiztreppn",
  "block.minecraft.jungle_stairs": "tropnhoiztreppn",
  "block.minecraft.crimson_stairs": "karmesintreppn",
  "block.minecraft.warped_stairs": "wirrtreppn",
  "block.minecraft.command_block": "befehlsblock",
  "block.minecraft.beacon": "leichtfeia",
  "block.minecraft.cobblestone_wall": "bruchstoamaua",
  "block.minecraft.mossy_cobblestone_wall": "bemooste bruchstoamaua",
  "block.minecraft.brick_wall": "ziaglmaua",
  "block.minecraft.prismarine_wall": "prismarinmaua",
  "block.minecraft.red_sandstone_wall": "rote sondstoamaua",
  "block.minecraft.mossy_stone_brick_wall": "bemooste bruchstoamaua",
  "block.minecraft.granite_wall": "granitmaua",
  "block.minecraft.stone_brick_wall": "stoaziaglmaua",
  "block.minecraft.nether_brick_wall": "netherziaglmaua",
  "block.minecraft.andesite_wall": "andesitmaua",
  "block.minecraft.red_nether_brick_wall": "rote netherziaglmaua",
  "block.minecraft.sandstone_wall": "sondstoamaua",
  "block.minecraft.end_stone_brick_wall": "endstoaziaglmaua",
  "block.minecraft.diorite_wall": "dioritmaua",
  "block.minecraft.blackstone_wall": "schworzstoamaua",
  "block.minecraft.polished_blackstone_wall": "poliate schworstoamaua",
  "block.minecraft.polished_blackstone_brick_wall": "poliate schworzstoaziaglmaua",
  "block.minecraft.stone_button": "stoaknopf",
  "block.minecraft.oak_button": "oachnhoizknopf",
  "block.minecraft.spruce_button": "fichtnhoizknopf",
  "block.minecraft.birch_button": "birknhoizknopf",
  "block.minecraft.jungle_button": "tropnhoizknopf",
  "block.minecraft.acacia_button": "akazienhoizknopf",
  "block.minecraft.dark_oak_button": "schworzoachnhoizknopf",
  "block.minecraft.crimson_button": "karmesinknopf",
  "block.minecraft.warped_button": "wirrknopf",
  "block.minecraft.polished_blackstone_button": "poliata schworzstoaknopf",
  "block.minecraft.anvil": "amboss",
  "block.minecraft.chipped_anvil": "ugschlogena amboss",
  "block.minecraft.damaged_anvil": "beschädigta amboss",
  "block.minecraft.trapped_chest": "redstonekistn",
  "block.minecraft.light_weighted_pressure_plate": "feinwägeplottn",
  "block.minecraft.heavy_weighted_pressure_plate": "grobwägeplottn",
  "block.minecraft.daylight_detector": "togeslichtsensor",
  "block.minecraft.redstone_block": "redstone-block",
  "block.minecraft.nether_quartz_ore": "netherquarzerz",
  "block.minecraft.hopper": "trichta",
  "block.minecraft.chiseled_quartz_block": "gmoaßlta quarzblock",
  "block.minecraft.quartz_block": "quarzblock",
  "block.minecraft.quartz_bricks": "quarzziagl",
  "block.minecraft.quartz_pillar": "quarzsäule",
  "block.minecraft.quartz_stairs": "quarztreppn",
  "block.minecraft.activator_rail": "aktivierungsschiene",
  "block.minecraft.dropper": "spenda",
  "block.minecraft.white_terracotta": "weiße keramik",
  "block.minecraft.orange_terracotta": "orange keramik",
  "block.minecraft.magenta_terracotta": "magentane keramik",
  "block.minecraft.light_blue_terracotta": "hellblaue keramik",
  "block.minecraft.yellow_terracotta": "gelbe keramik",
  "block.minecraft.lime_terracotta": "hellgrüne keramik",
  "block.minecraft.pink_terracotta": "rosane keramik",
  "block.minecraft.gray_terracotta": "graue keramik",
  "block.minecraft.light_gray_terracotta": "hellgraue keramik",
  "block.minecraft.cyan_terracotta": "türkise keramik",
  "block.minecraft.purple_terracotta": "lilane keramik",
  "block.minecraft.blue_terracotta": "blaue keramik",
  "block.minecraft.brown_terracotta": "braune keramik",
  "block.minecraft.green_terracotta": "grüne keramik",
  "block.minecraft.red_terracotta": "rote keramik",
  "block.minecraft.black_terracotta": "schworze keramik",
  "block.minecraft.barrier": "barriere",
  "block.minecraft.iron_trapdoor": "eisnfoitir",
  "block.minecraft.hay_block": "heiboin",
  "block.minecraft.white_carpet": "weißa teppich",
  "block.minecraft.orange_carpet": "oranga teppich",
  "block.minecraft.magenta_carpet": "magentana teppich",
  "block.minecraft.light_blue_carpet": "hellblaua teppich",
  "block.minecraft.yellow_carpet": "gelba teppich",
  "block.minecraft.lime_carpet": "hellgrüna teppich",
  "block.minecraft.pink_carpet": "rosana teppich",
  "block.minecraft.gray_carpet": "graua teppich",
  "block.minecraft.light_gray_carpet": "hellgraua teppich",
  "block.minecraft.cyan_carpet": "türkisa teppich",
  "block.minecraft.purple_carpet": "lilana teppich",
  "block.minecraft.blue_carpet": "blaua teppich",
  "block.minecraft.brown_carpet": "brauna teppich",
  "block.minecraft.green_carpet": "grüna teppich",
  "block.minecraft.red_carpet": "rota teppich",
  "block.minecraft.black_carpet": "schworza teppich",
  "block.minecraft.terracotta": "keramik",
  "block.minecraft.coal_block": "kohleblock",
  "block.minecraft.packed_ice": "pockeis",
  "block.minecraft.acacia_stairs": "akazienhoiztreppn",
  "block.minecraft.dark_oak_stairs": "schworzoachnhoiztreppn",
  "block.minecraft.slime_block": "schleimblock",
  "block.minecraft.grass_path": "grosweg",
  "block.minecraft.sunflower": "sonnenblume",
  "block.minecraft.lilac": "flieda",
  "block.minecraft.rose_bush": "rosnstrauch",
  "block.minecraft.peony": "pfingstrosn",
  "block.minecraft.tall_grass": "hochs gros",
  "block.minecraft.large_fern": "großa farn",
  "block.minecraft.white_stained_glass": "weißs glos",
  "block.minecraft.orange_stained_glass": "orangs glos",
  "block.minecraft.magenta_stained_glass": "magentas glos",
  "block.minecraft.light_blue_stained_glass": "hellblaus glos",
  "block.minecraft.yellow_stained_glass": "gelbs glos",
  "block.minecraft.lime_stained_glass": "hellgrüns glos",
  "block.minecraft.pink_stained_glass": "rosas glos",
  "block.minecraft.gray_stained_glass": "graus glos",
  "block.minecraft.light_gray_stained_glass": "hellgraus glos",
  "block.minecraft.cyan_stained_glass": "türkises glos",
  "block.minecraft.purple_stained_glass": "lilas glos",
  "block.minecraft.blue_stained_glass": "blaus glos",
  "block.minecraft.brown_stained_glass": "brauns glos",
  "block.minecraft.green_stained_glass": "grüns glos",
  "block.minecraft.red_stained_glass": "rots glos",
  "block.minecraft.black_stained_glass": "schworzs glos",
  "block.minecraft.white_stained_glass_pane": "weiße glosscheibn",
  "block.minecraft.orange_stained_glass_pane": "orange glosscheibn",
  "block.minecraft.magenta_stained_glass_pane": "magentane glosscheibn",
  "block.minecraft.light_blue_stained_glass_pane": "hellblaue glosscheibn",
  "block.minecraft.yellow_stained_glass_pane": "gelbe glosscheibn",
  "block.minecraft.lime_stained_glass_pane": "hellgrüne glosscheibn",
  "block.minecraft.pink_stained_glass_pane": "rosane glosscheibn",
  "block.minecraft.gray_stained_glass_pane": "graue glosscheibn",
  "block.minecraft.light_gray_stained_glass_pane": "hellgraue glosscheibn",
  "block.minecraft.cyan_stained_glass_pane": "türkise glosscheibn",
  "block.minecraft.purple_stained_glass_pane": "lilane glosscheibn",
  "block.minecraft.blue_stained_glass_pane": "blaue glosscheibn",
  "block.minecraft.brown_stained_glass_pane": "braune glosscheibn",
  "block.minecraft.green_stained_glass_pane": "grüne glosscheibn",
  "block.minecraft.red_stained_glass_pane": "rote glosscheibn",
  "block.minecraft.black_stained_glass_pane": "schworze glosscheibn",
  "block.minecraft.prismarine": "prismarin",
  "block.minecraft.prismarine_bricks": "prismarinziagl",
  "block.minecraft.dark_prismarine": "dunkla prismarin",
  "block.minecraft.prismarine_stairs": "prismarintreppn",
  "block.minecraft.prismarine_brick_stairs": "prismarinziagltreppn",
  "block.minecraft.dark_prismarine_stairs": "dunkle prismarintreppn",
  "block.minecraft.sea_lantern": "seelatern",
  "block.minecraft.red_sandstone": "rota sondstoa",
  "block.minecraft.chiseled_red_sandstone": "gmoaßlta rota sondstoa",
  "block.minecraft.cut_red_sandstone": "gschnittena rota sondstoa",
  "block.minecraft.red_sandstone_stairs": "rote sondstoatreppn",
  "block.minecraft.repeating_command_block": "wiedahoi-befehlsblock",
  "block.minecraft.chain_command_block": "kettn-befehlsblock",
  "block.minecraft.magma_block": "magmablock",
  "block.minecraft.nether_wart_block": "netherwarznblock",
  "block.minecraft.warped_wart_block": "wirrwarznblock",
  "block.minecraft.red_nether_bricks": "rote netherziagl",
  "block.minecraft.bone_block": "knochnblock",
  "block.minecraft.structure_void": "konstruktionsleere",
  "block.minecraft.observer": "beobochta",
  "block.minecraft.shulker_box": "shulkerkistn",
  "block.minecraft.white_shulker_box": "weiße shulkerkistn",
  "block.minecraft.orange_shulker_box": "orange shulkerkistn",
  "block.minecraft.magenta_shulker_box": "magentane shulkerkistn",
  "block.minecraft.light_blue_shulker_box": "hellblaue shulkerkistn",
  "block.minecraft.yellow_shulker_box": "gelbe shulkerkistn",
  "block.minecraft.lime_shulker_box": "hellgrüne shulkerkistn",
  "block.minecraft.pink_shulker_box": "rosane shulkerkistn",
  "block.minecraft.gray_shulker_box": "graue shulkerkistn",
  "block.minecraft.light_gray_shulker_box": "hellgraue shulkerkistn",
  "block.minecraft.cyan_shulker_box": "türkise shulkerkistn",
  "block.minecraft.purple_shulker_box": "lilane shulkerkistn",
  "block.minecraft.blue_shulker_box": "blaue shulkerkistn",
  "block.minecraft.brown_shulker_box": "braune shulkerkistn",
  "block.minecraft.green_shulker_box": "grüne shulkerkistn",
  "block.minecraft.red_shulker_box": "rote shulkerkistn",
  "block.minecraft.black_shulker_box": "schworze shulkerkistn",
  "block.minecraft.white_glazed_terracotta": "weiß glosiate keramik",
  "block.minecraft.orange_glazed_terracotta": "orange glosiate keramik",
  "block.minecraft.magenta_glazed_terracotta": "magenta glosiate keramik",
  "block.minecraft.light_blue_glazed_terracotta": "hellblau glosiate keramik",
  "block.minecraft.yellow_glazed_terracotta": "gelb glosiate keramik",
  "block.minecraft.lime_glazed_terracotta": "hellgrün glosiate keramik",
  "block.minecraft.pink_glazed_terracotta": "rosa glosiate keramik",
  "block.minecraft.gray_glazed_terracotta": "grau glosiate keramik",
  "block.minecraft.light_gray_glazed_terracotta": "hellgrau glosiate keramik",
  "block.minecraft.cyan_glazed_terracotta": "türkis glosiate keramik",
  "block.minecraft.purple_glazed_terracotta": "lila glosiate keramik",
  "block.minecraft.blue_glazed_terracotta": "blau glosiate keramik",
  "block.minecraft.brown_glazed_terracotta": "braun glosiate keramik",
  "block.minecraft.green_glazed_terracotta": "grün glosiate keramik",
  "block.minecraft.red_glazed_terracotta": "rot glosiate keramik",
  "block.minecraft.black_glazed_terracotta": "schworz glosiate keramik",
  "block.minecraft.white_concrete": "weißa beton",
  "block.minecraft.orange_concrete": "oranga beton",
  "block.minecraft.magenta_concrete": "magentana beton",
  "block.minecraft.light_blue_concrete": "hellblaua beton",
  "block.minecraft.yellow_concrete": "gelba beton",
  "block.minecraft.lime_concrete": "hellgrüna beton",
  "block.minecraft.pink_concrete": "rosana beton",
  "block.minecraft.gray_concrete": "graua beton",
  "block.minecraft.light_gray_concrete": "hellgraua beton",
  "block.minecraft.cyan_concrete": "türkisa beton",
  "block.minecraft.purple_concrete": "lilana beton",
  "block.minecraft.blue_concrete": "blaua beton",
  "block.minecraft.brown_concrete": "brauna beton",
  "block.minecraft.green_concrete": "grüna beton",
  "block.minecraft.red_concrete": "rota beton",
  "block.minecraft.black_concrete": "schworza beton",
  "block.minecraft.white_concrete_powder": "weißa trocknbeton",
  "block.minecraft.orange_concrete_powder": "oranga trocknbeton",
  "block.minecraft.magenta_concrete_powder": "magentana trocknbeton",
  "block.minecraft.light_blue_concrete_powder": "hellblaua trocknbeton",
  "block.minecraft.yellow_concrete_powder": "gelba trocknbeton",
  "block.minecraft.lime_concrete_powder": "hellgrüna trocknbeton",
  "block.minecraft.pink_concrete_powder": "rosana trocknbeton",
  "block.minecraft.gray_concrete_powder": "graua trocknbeton",
  "block.minecraft.light_gray_concrete_powder": "hellgraua trocknbeton",
  "block.minecraft.cyan_concrete_powder": "türkisa trocknbeton",
  "block.minecraft.purple_concrete_powder": "lilana trocknbeton",
  "block.minecraft.blue_concrete_powder": "blaua trocknbeton",
  "block.minecraft.brown_concrete_powder": "brauna trocknbeton",
  "block.minecraft.green_concrete_powder": "grüna trocknbeton",
  "block.minecraft.red_concrete_powder": "rota trocknbeton",
  "block.minecraft.black_concrete_powder": "schworza trocknbeton",
  "block.minecraft.turtle_egg": "schüdkrötnei",
  "block.minecraft.dead_tube_coral_block": "obgstorbena orglkorallnblock",
  "block.minecraft.dead_brain_coral_block": "obgstorbena hiankorallnblock",
  "block.minecraft.dead_bubble_coral_block": "obgstorbena blosnkorallnblock",
  "block.minecraft.dead_fire_coral_block": "obgstorbena feiakorallnblock",
  "block.minecraft.dead_horn_coral_block": "obgstorbena geweihkorallnblock",
  "block.minecraft.tube_coral_block": "orglkorallnblock",
  "block.minecraft.brain_coral_block": "hiankorallnblock",
  "block.minecraft.bubble_coral_block": "blosnkorallnblock",
  "block.minecraft.fire_coral_block": "feiakorallnblock",
  "block.minecraft.horn_coral_block": "geweihkorallnblock",
  "block.minecraft.tube_coral": "orglkoralln",
  "block.minecraft.brain_coral": "hiankoralln",
  "block.minecraft.bubble_coral": "blosnkoralln",
  "block.minecraft.fire_coral": "feiakoralln",
  "block.minecraft.horn_coral": "geweihkoralln",
  "block.minecraft.dead_brain_coral": "obgstorbene hiankoralln",
  "block.minecraft.dead_bubble_coral": "obgstorbene blosnkoralle",
  "block.minecraft.dead_fire_coral": "obgstorbene feiakoralln",
  "block.minecraft.dead_horn_coral": "obgstorbene geweihkoralle",
  "block.minecraft.dead_tube_coral": "obgstorbene orglkoralln",
  "block.minecraft.tube_coral_fan": "orglkorallnfächa",
  "block.minecraft.brain_coral_fan": "hiankorallnfächa",
  "block.minecraft.bubble_coral_fan": "blosnkorallnfächa",
  "block.minecraft.fire_coral_fan": "feiakorallnfächa",
  "block.minecraft.horn_coral_fan": "geweihkorallnfächa",
  "block.minecraft.dead_tube_coral_fan": "obgstorbena orglkorallnfächa",
  "block.minecraft.dead_brain_coral_fan": "obgstorbena hiankorallnfächa",
  "block.minecraft.dead_bubble_coral_fan": "obgstorbena blosnkorallnfächa",
  "block.minecraft.dead_fire_coral_fan": "obgstorbena feiakorallnfächa",
  "block.minecraft.dead_horn_coral_fan": "obgstorbena geweihkorallnfächa",
  "block.minecraft.blue_ice": "blaus eis",
  "block.minecraft.conduit": "aquisator",
  "block.minecraft.polished_granite_stairs": "poliate granittreppn",
  "block.minecraft.smooth_red_sandstone_stairs": "glotte rote stondstoatreppn",
  "block.minecraft.mossy_stone_brick_stairs": "bemooste stoaziagltreppn",
  "block.minecraft.polished_diorite_stairs": "poliate diorittreppn",
  "block.minecraft.mossy_cobblestone_stairs": "bemooste bruchstoatreppn",
  "block.minecraft.end_stone_brick_stairs": "endstoaziagltreppn",
  "block.minecraft.stone_stairs": "stoatreppn",
  "block.minecraft.smooth_sandstone_stairs": "glotte sondstoatreppn",
  "block.minecraft.smooth_quartz_stairs": "glotte quarztreppn",
  "block.minecraft.granite_stairs": "granittreppn",
  "block.minecraft.andesite_stairs": "andestittreppn",
  "block.minecraft.red_nether_brick_stairs": "rote netherziagltreppn",
  "block.minecraft.polished_andesite_stairs": "poliate andesittreppn",
  "block.minecraft.diorite_stairs": "diorittreppn",
  "block.minecraft.polished_granite_slab": "poliate granitstufn",
  "block.minecraft.smooth_red_sandstone_slab": "glotte rote stondstoastufn",
  "block.minecraft.mossy_stone_brick_slab": "bemooste stoaziaglstufn",
  "block.minecraft.polished_diorite_slab": "poliate dioritstufn",
  "block.minecraft.mossy_cobblestone_slab": "bemooste bruchstoastufn",
  "block.minecraft.end_stone_brick_slab": "endstoaziaglstufn",
  "block.minecraft.smooth_sandstone_slab": "glotte sondstoastufn",
  "block.minecraft.smooth_quartz_slab": "glotte quarzstufn",
  "block.minecraft.granite_slab": "granitstufn",
  "block.minecraft.andesite_slab": "andesitstufn",
  "block.minecraft.red_nether_brick_slab": "rote netherziaglstufn",
  "block.minecraft.polished_andesite_slab": "poliate andesitstufn",
  "block.minecraft.diorite_slab": "dioritstufn",
  "block.minecraft.scaffolding": "grüst",
  "block.minecraft.iron_door": "eisntir",
  "block.minecraft.oak_door": "oachnhoiztir",
  "block.minecraft.spruce_door": "fichtnhoiztir",
  "block.minecraft.birch_door": "birknhoiztir",
  "block.minecraft.jungle_door": "tropnhoiztir",
  "block.minecraft.acacia_door": "akazienhoiztir",
  "block.minecraft.dark_oak_door": "schworzoachnhoiztir",
  "block.minecraft.crimson_door": "karmesintir",
  "block.minecraft.warped_door": "wirrtir",
  "block.minecraft.repeater": "redstone-vastärka",
  "block.minecraft.comparator": "redstone-komparator",
  "block.minecraft.structure_block": "konstruktionsblock",
  "block.minecraft.jigsaw": "vabundblock",
  "item.minecraft.turtle_helmet": "schüdkrötnponza□□am kopf:□+2 rüstung",
  "item.minecraft.scute": "hornschüd",
  "item.minecraft.iron_shovel": "eisnschaufe□□in da haupthond:□+3.5 ongriffsschodn□-3 ongriffsgschwindigkeit",
  "item.minecraft.iron_pickaxe": "eisnspitzhock□□in da haupthond:□+3 ongriffsschodn□-2.8 ongriffsgschwindigkeit",
  "item.minecraft.iron_axe": "eisnoxt□□in da haupthond:□+8 ongriffsschodn□-3.1 ongriffsgschwindigkeit",
  "item.minecraft.flint_and_steel": "feiazeig",
  "item.minecraft.apple": "opfe",
  "item.minecraft.bow": "bogn",
  "item.minecraft.arrow": "pfeil",
  "item.minecraft.coal": "kohle",
  "item.minecraft.charcoal": "hoizkohle",
  "item.minecraft.diamond": "diamant",
  "item.minecraft.iron_ingot": "eisnborrn",
  "item.minecraft.gold_ingot": "goidborrn",
  "item.minecraft.netherite_ingot": "netheritborrn",
  "item.minecraft.netherite_scrap": "netheritbrockn",
  "item.minecraft.iron_sword": "eisnschwert□□in da haupthond:□+5 ongriffsschodn□-2.4 ongriffsgschwindigkeit",
  "item.minecraft.wooden_sword": "hoizschwert□□in da haupthond:□+3 ongriffsschodn□-2.4 ongriffsgschwindigkeit",
  "item.minecraft.wooden_shovel": "hoizschaufe□□in da haupthond:□+1.5 ongriffsschodn□-3 ongriffsgschwindigkeit",
  "item.minecraft.wooden_pickaxe": "hoizspitzhock□□in da haupthond:□+1 ongriffsschodn□-2.8 ongriffsgschwindigkeit",
  "item.minecraft.wooden_axe": "hoizoxt□□in da haupthond:□+6 ongriffsschodn□-3.2 ongriffsgschwindigkeit",
  "item.minecraft.stone_sword": "stoaschwert□□in da haupthond:□+4 ongriffsschodn□-2.4 ongriffsgschwindigkeit",
  "item.minecraft.stone_shovel": "stoaschaufe□□in da haupthond:□+2.5 ongriffsschodn□-3 ongriffsgschwindigkeit",
  "item.minecraft.stone_pickaxe": "stoaspitzhock□□in da haupthond:□+2 ongriffsschodn□-2.8 ongriffsgschwindigkeit",
  "item.minecraft.stone_axe": "stoaoxt□□in da haupthond:□+8 ongriffsschodn□-3.2 ongriffsgschwindigkeit",
  "item.minecraft.diamond_sword": "diamantschwert□□in da haupthond:□+6 ongriffsschodn□-2.4 ongriffsgschwindigkeit",
  "item.minecraft.diamond_shovel": "diamantschaufe□□in da haupthond:□+4.5 ongriffsschodn□-3 ongriffsgschwindigkeit",
  "item.minecraft.diamond_pickaxe": "diamantspitzhock□□in da haupthond:□+4 ongriffsschodn□-2.8 ongriffsgschwindigkeit",
  "item.minecraft.diamond_axe": "diamantoxt□□in da haupthond:□+8 ongriffsschodn□-3 ongriffsgschwindigkeit",
  "item.minecraft.stick": "stock",
  "item.minecraft.bowl": "schissl",
  "item.minecraft.mushroom_stew": "püzsuppn",
  "item.minecraft.golden_sword": "goidschwert□□in da haupthond:□+3 ongriffsschodn□-2.4 ongriffsgschwindigkeit",
  "item.minecraft.golden_shovel": "goidschaufe□□in da haupthond:□+1.5 ongriffsschodn□-3 ongriffsgschwindigkeit",
  "item.minecraft.golden_pickaxe": "goidspitzhock□□in da haupthond:□+1 ongriffsschodn□-2.8 ongriffsgschwindigkeit",
  "item.minecraft.golden_axe": "goidoxt□□in da haupthond:□+6 ongriffsschodn□-3 ongriffsgschwindigkeit",
  "item.minecraft.netherite_sword": "netheritschwert□□in da haupthond:□+7 ongriffsschodn□-2.4 ongriffsgschwindigkeit",
  "item.minecraft.netherite_shovel": "netheritschaufe□□in da haupthond:□+5.5 ongriffsschodn□-3 ongriffsgschwindigkeit",
  "item.minecraft.netherite_pickaxe": "netheritspitzhock□□in da haupthond:□+5 ongriffsschodn□-2.8 ongriffsgschwindigkeit",
  "item.minecraft.netherite_axe": "netheritoxt□□in da haupthond:□+9 ongriffsschodn□-3 ongriffsgschwindigkeit",
  "item.minecraft.string": "fodn",
  "item.minecraft.feather": "feda",
  "item.minecraft.gunpowder": "schworzpuiva",
  "item.minecraft.wooden_hoe": "hoizhock□□in da haupthond:□-3 ongriffsgschwindigkeit",
  "item.minecraft.stone_hoe": "stoahock□□in da haupthond:□-2 ongriffsgschwindigkeit",
  "item.minecraft.iron_hoe": "eisnhock□□in da haupthond:□-1 ongriffsgschwindigkeit",
  "item.minecraft.diamond_hoe": "diamanthock□□in da haupthond:",
  "item.minecraft.golden_hoe": "goidhock□□in da haupthond:□-3 ongriffsgschwindigkeit",
  "item.minecraft.netherite_hoe": "netherithock□□in da haupthond:",
  "item.minecraft.wheat_seeds": "weiznkern",
  "item.minecraft.wheat": "weizn",
  "item.minecraft.bread": "brot",
  "item.minecraft.leather_helmet": "ledakoppn□□am kopf:□+1 rüstung",
  "item.minecraft.leather_chestplate": "ledajanka□□am körpa:□+3 rüstung",
  "item.minecraft.leather_leggings": "ledahosn□□an de haxn:□+2 rüstung",
  "item.minecraft.leather_boots": "ledastiefe□□an de fiaß:□+1 rüstung",
  "item.minecraft.chainmail_helmet": "kettnhaubn□□am kopf:□+2 rüstung",
  "item.minecraft.chainmail_chestplate": "kettnhemd□□am körpa:□+5 rüstung",
  "item.minecraft.chainmail_leggings": "kettnhosn□□an de haxn:□+4 rüstung",
  "item.minecraft.chainmail_boots": "kettnstiefe□□an de fiaß:□+1 rüstung",
  "item.minecraft.iron_helmet": "eisnhöm□□am kopf:□+2 rüstung",
  "item.minecraft.iron_chestplate": "eisnbrustplottn□□am körpa:□+6 rüstung",
  "item.minecraft.iron_leggings": "eisnhaxnschutz□□an de haxn:□+5 rüstung",
  "item.minecraft.iron_boots": "eisnstiefe□□an de fiaß:□+2 rüstung",
  "item.minecraft.diamond_helmet": "diamanthöm□□am kopf:□+3 rüstung□+2 rüstungshärte",
  "item.minecraft.diamond_chestplate": "diamantbrustplottn□□am körpa:□+8 rüstung□+2 rüstungshärte",
  "item.minecraft.diamond_leggings": "diamanthaxnschutz□□an de haxn:□+6 rüstung□+2 rüstungshärte",
  "item.minecraft.diamond_boots": "diamantstiefe□□an de fiaß:□+3 rüstung□+2 rüstungshärte",
  "item.minecraft.golden_helmet": "goidhöm□□am kopf:□+2 rüstung",
  "item.minecraft.golden_chestplate": "goidbrustplottn□□am körpa:□+5 rüstung",
  "item.minecraft.golden_leggings": "goidhaxnschutz□□an de haxn:□+3 rüstung",
  "item.minecraft.golden_boots": "goidstiefe□□an de fiaß:□+1 rüstung",
  "item.minecraft.netherite_helmet": "netherithöm□□am kopf:□+3 rüstung□+3 rüstungshärte□+1 stondfestigkeit",
  "item.minecraft.netherite_chestplate": "netheritbrustplatte□□am körpa:□+8 rüstung□+3 rüstungshärte□+1 stondfestigkeit",
  "item.minecraft.netherite_leggings": "netherithaxnschutz□□an de haxn:□+6 rüstung□+3 rüstungshärte□+1 stondfestigkeit",
  "item.minecraft.netherite_boots": "netheritstiefe□□an de fiaß:□+3 rüstung□+3 rüstungshärte□+1 stondfestigkeit",
  "item.minecraft.flint": "feiastoa",
  "item.minecraft.porkchop": "ruachs schweinefleisch",
  "item.minecraft.cooked_porkchop": "schweinsbrotn",
  "item.minecraft.painting": "büd",
  "item.minecraft.golden_apple": "goidana opfe",
  "item.minecraft.enchanted_golden_apple": "vazaubata goidana opfe",
  "block.minecraft.oak_sign": "oachnhoizschüd",
  "block.minecraft.spruce_sign": "fichtnhoizschüd",
  "block.minecraft.birch_sign": "birknhoizschüd",
  "block.minecraft.jungle_sign": "dschunglhoizschüd",
  "block.minecraft.acacia_sign": "akazienhoizschüd",
  "block.minecraft.dark_oak_sign": "schworzoachnhoizschüd",
  "block.minecraft.crimson_sign": "karmesinschüd",
  "block.minecraft.warped_sign": "wirrschüd",
  "item.minecraft.bucket": "kiwe",
  "item.minecraft.water_bucket": "wossakiwe",
  "item.minecraft.lava_bucket": "lavakiwe",
  "item.minecraft.minecart": "wagon",
  "item.minecraft.saddle": "sottl",
  "item.minecraft.redstone": "redstone-stab",
  "item.minecraft.snowball": "schneeboi",
  "item.minecraft.oak_boat": "oachnhoizboot",
  "item.minecraft.leather": "leda",
  "item.minecraft.milk_bucket": "milchkibl",
  "item.minecraft.pufferfish_bucket": "kuglfischkiwe",
  "item.minecraft.salmon_bucket": "lachskiwe",
  "item.minecraft.cod_bucket": "kabeljaukiwe",
  "item.minecraft.tropical_fish_bucket": "tropnfischkiwe",
  "item.minecraft.brick": "ziagl",
  "item.minecraft.clay_ball": "tonklumpen",
  "block.minecraft.dried_kelp_block": "trockneta seetongblock",
  "item.minecraft.paper": "papia",
  "item.minecraft.book": "buach",
  "item.minecraft.slime_ball": "schleimboi",
  "item.minecraft.chest_minecart": "wagon mit kistn",
  "item.minecraft.furnace_minecart": "wagon mit ofn",
  "item.minecraft.egg": "ei",
  "item.minecraft.compass": "kompass",
  "item.minecraft.fishing_rod": "ongl",
  "item.minecraft.clock": "uhr",
  "item.minecraft.glowstone_dust": "glowstonestab",
  "item.minecraft.cod": "ruacha kabeljau",
  "item.minecraft.salmon": "ruacha lachs",
  "item.minecraft.tropical_fish": "tropnfisch",
  "item.minecraft.pufferfish": "kuglfisch",
  "item.minecraft.cooked_cod": "brotna kabeljau",
  "item.minecraft.cooked_salmon": "brotna lachs",
  "item.minecraft.ink_sac": "tintnbeitl",
  "item.minecraft.red_dye": "rote forb",
  "item.minecraft.green_dye": "grüne forb",
  "item.minecraft.cocoa_beans": "kakaobohnen",
  "item.minecraft.lapis_lazuli": "lapislazuli",
  "item.minecraft.purple_dye": "lilane forb",
  "item.minecraft.cyan_dye": "türkise forb",
  "item.minecraft.light_gray_dye": "hellgraue forb",
  "item.minecraft.gray_dye": "graue forb",
  "item.minecraft.pink_dye": "rosane forb",
  "item.minecraft.lime_dye": "hellgrüne forb",
  "item.minecraft.yellow_dye": "gelbe forb",
  "item.minecraft.light_blue_dye": "hellblaue forb",
  "item.minecraft.magenta_dye": "magentane forb",
  "item.minecraft.orange_dye": "orange forb",
  "item.minecraft.bone_meal": "knochnmöh",
  "item.minecraft.blue_dye": "blaue forb",
  "item.minecraft.brown_dye": "braune forb",
  "item.minecraft.black_dye": "schworze forb",
  "item.minecraft.white_dye": "weiße forb",
  "item.minecraft.bone": "knochn",
  "item.minecraft.sugar": "zugga",
  "block.minecraft.cake": "kuachn",
  "block.minecraft.white_bed": "weißs bett",
  "block.minecraft.orange_bed": "orangs bett",
  "block.minecraft.magenta_bed": "magentas bett",
  "block.minecraft.light_blue_bed": "hellblaus bett",
  "block.minecraft.yellow_bed": "gelbs bett",
  "block.minecraft.lime_bed": "hellgrüns bett",
  "block.minecraft.pink_bed": "rosas bett",
  "block.minecraft.gray_bed": "graus bett",
  "block.minecraft.light_gray_bed": "hellgraus bett",
  "block.minecraft.cyan_bed": "türkises bett",
  "block.minecraft.purple_bed": "lilas bett",
  "block.minecraft.blue_bed": "blaus bett",
  "block.minecraft.brown_bed": "brauns bett",
  "block.minecraft.green_bed": "grüns bett",
  "block.minecraft.red_bed": "rots bett",
  "block.minecraft.black_bed": "schworzs bett",
  "item.minecraft.cookie": "keks",
  "item.minecraft.filled_map": "kortn□#0",
  "item.minecraft.shears": "schar",
  "item.minecraft.melon_slice": "melonenscheibn",
  "item.minecraft.dried_kelp": "trockneta seetong",
  "item.minecraft.pumpkin_seeds": "kürbiskeandl",
  "item.minecraft.melon_seeds": "melonenkeandl",
  "item.minecraft.beef": "ruachs rindfleisch",
  "item.minecraft.cooked_beef": "steak",
  "item.minecraft.chicken": "ruachs hendl",
  "item.minecraft.cooked_chicken": "brotns hendl",
  "item.minecraft.rotten_flesh": "varottets fleisch",
  "item.minecraft.ender_pearl": "enderperle",
  "item.minecraft.blaze_rod": "lohenrutn",
  "item.minecraft.ghast_tear": "ghastträne",
  "item.minecraft.gold_nugget": "goidklumpn",
  "item.minecraft.nether_wart": "netherwarzn",
  "item.minecraft.potion": "ned braubora tronk□wirkungslos",
  "item.minecraft.glass_bottle": "glosflosch",
  "item.minecraft.spider_eye": "spinnenaug",
  "item.minecraft.fermented_spider_eye": "fermentiads spinnenaug",
  "item.minecraft.blaze_powder": "lohnstab",
  "item.minecraft.magma_cream": "magmacreme",
  "block.minecraft.brewing_stand": "braustond",
  "block.minecraft.cauldron": "kessl",
  "item.minecraft.ender_eye": "enderaug",
  "item.minecraft.glistering_melon_slice": "glitzande melonenscheibn",
  "item.minecraft.bat_spawn_egg": "fledamaus-spawn-ei",
  "item.minecraft.bee_spawn_egg": "bienen-spawn-ei",
  "item.minecraft.blaze_spawn_egg": "lohen-spawn-ei",
  "item.minecraft.cat_spawn_egg": "kotz-spawn-ei",
  "item.minecraft.cave_spider_spawn_egg": "höhlnspinn-spawn-ei",
  "item.minecraft.chicken_spawn_egg": "hendl-spawn-ei",
  "item.minecraft.cod_spawn_egg": "kabeljau-spawn-ei",
  "item.minecraft.cow_spawn_egg": "kua-spawn-ei",
  "item.minecraft.creeper_spawn_egg": "creeper-spawn-ei",
  "item.minecraft.dolphin_spawn_egg": "delfin-spawn-ei",
  "item.minecraft.donkey_spawn_egg": "esl-spawn-ei",
  "item.minecraft.drowned_spawn_egg": "ertrunkena-spawn-ei",
  "item.minecraft.elder_guardian_spawn_egg": "großa-wächta-spawn-ei",
  "item.minecraft.enderman_spawn_egg": "enderman-spawn-ei",
  "item.minecraft.endermite_spawn_egg": "endermite-spawn-ei",
  "item.minecraft.evoker_spawn_egg": "magier-spawn-ei",
  "item.minecraft.fox_spawn_egg": "fux-spawn-ei",
  "item.minecraft.ghast_spawn_egg": "ghast-spawn-ei",
  "item.minecraft.guardian_spawn_egg": "wächta-spawn-ei",
  "item.minecraft.hoglin_spawn_egg": "hoglin-spawn-ei",
  "item.minecraft.horse_spawn_egg": "roß-spawn-ei",
  "item.minecraft.husk_spawn_egg": "wüstnzombie-spawn-ei",
  "item.minecraft.llama_spawn_egg": "lama-spawn-ei",
  "item.minecraft.magma_cube_spawn_egg": "magmawürlf-spawn-ei",
  "item.minecraft.mooshroom_spawn_egg": "mooshroom-spawn-ei",
  "item.minecraft.mule_spawn_egg": "maultier-spawn-ei",
  "item.minecraft.ocelot_spawn_egg": "ozelot-spawn-ei",
  "item.minecraft.panda_spawn_egg": "panda-spawn-ei",
  "item.minecraft.parrot_spawn_egg": "popagei-spawn-ei",
  "item.minecraft.phantom_spawn_egg": "phantom-spawn-ei",
  "item.minecraft.pig_spawn_egg": "schwein-spawn-ei",
  "item.minecraft.piglin_spawn_egg": "piglin-spawn-ei",
  "item.minecraft.pillager_spawn_egg": "plündara-spawn-ei",
  "item.minecraft.polar_bear_spawn_egg": "eisbär-spawn-ei",
  "item.minecraft.pufferfish_spawn_egg": "kuglfisch-spawn-ei",
  "item.minecraft.rabbit_spawn_egg": "hos-spawn-ei",
  "item.minecraft.ravager_spawn_egg": "vawüsta-spawn-ei",
  "item.minecraft.salmon_spawn_egg": "lachs-spawn-ei",
  "item.minecraft.sheep_spawn_egg": "schafe-spawn-ei",
  "item.minecraft.shulker_spawn_egg": "shulker-spawn-ei",
  "item.minecraft.silverfish_spawn_egg": "sübafisch-spawn-ei",
  "item.minecraft.skeleton_spawn_egg": "skelett-spawn-ei",
  "item.minecraft.skeleton_horse_spawn_egg": "skelettroß-spawn-ei",
  "item.minecraft.slime_spawn_egg": "schleim-spawn-ei",
  "item.minecraft.spider_spawn_egg": "spinnen-spawn-ei",
  "item.minecraft.squid_spawn_egg": "tintnfisch-spawn-ei",
  "item.minecraft.stray_spawn_egg": "eiswondara-spawn-ei",
  "item.minecraft.strider_spawn_egg": "schreita-spawn-ei",
  "item.minecraft.trader_llama_spawn_egg": "händlalama-spawn-ei",
  "item.minecraft.tropical_fish_spawn_egg": "tropnfisch-spawn-ei",
  "item.minecraft.turtle_spawn_egg": "schüdkrötn-spawn-ei",
  "item.minecraft.vex_spawn_egg": "plogegeist-spawn-ei",
  "item.minecraft.villager_spawn_egg": "dorfbewohna-spawn-ei",
  "item.minecraft.vindicator_spawn_egg": "diena-spawn-ei",
  "item.minecraft.wandering_trader_spawn_egg": "fohrenda-händla-spawn-ei",
  "item.minecraft.witch_spawn_egg": "hexn-spawn-ei",
  "item.minecraft.wither_skeleton_spawn_egg": "witherskelett-spawn-ei",
  "item.minecraft.wolf_spawn_egg": "woif-spawn-ei",
  "item.minecraft.zoglin_spawn_egg": "zoglin-spawn-ei",
  "item.minecraft.zombie_spawn_egg": "zombie-spawn-ei",
  "item.minecraft.zombie_horse_spawn_egg": "zombieroß-spawn-ei",
  "item.minecraft.zombie_villager_spawn_egg": "dorfbewohnazombie-spawn-ei",
  "item.minecraft.zombified_piglin_spawn_egg": "zombifiziata-piglin-spawn-ei",
  "item.minecraft.experience_bottle": "erfohrungsflosch",
  "item.minecraft.fire_charge": "feiakugl",
  "item.minecraft.writable_book": "buach und feda",
  "item.minecraft.written_book": "beschriebns buach",
  "item.minecraft.emerald": "smaragd",
  "item.minecraft.item_frame": "rohmen",
  "block.minecraft.flower_pot": "blumentopf",
  "item.minecraft.carrot": "karottn",
  "item.minecraft.potato": "kartoffe",
  "item.minecraft.baked_potato": "ofnkartoffe",
  "item.minecraft.poisonous_potato": "giftige kartoffe",
  "item.minecraft.map": "laare kortn",
  "item.minecraft.golden_carrot": "goidane karottn",
  "block.minecraft.skeleton_skull": "skelettschädl",
  "block.minecraft.wither_skeleton_skull": "witherskelettschädl",
  "block.minecraft.player_head": "spielakopf",
  "block.minecraft.zombie_head": "zombiekopf",
  "block.minecraft.creeper_head": "creeperkopf",
  "block.minecraft.dragon_head": "drochnkopf",
  "item.minecraft.carrot_on_a_stick": "karottnongl",
  "item.minecraft.warped_fungus_on_a_stick": "wirrpüzongl",
  "item.minecraft.nether_star": "netherstern",
  "item.minecraft.pumpkin_pie": "kürbiskuachn",
  "item.minecraft.firework_rocket": "feiawerksraketn",
  "item.minecraft.firework_star": "feiawerksstern",
  "item.minecraft.enchanted_book": "vazaubats buach",
  "item.minecraft.nether_brick": "netherziagl",
  "item.minecraft.quartz": "netherquarz",
  "item.minecraft.tnt_minecart": "wagon mit tnt",
  "item.minecraft.hopper_minecart": "wagon mit trichta",
  "item.minecraft.prismarine_shard": "prismarinscherbe",
  "item.minecraft.prismarine_crystals": "prismarinkristoi",
  "item.minecraft.rabbit": "ruacha hos",
  "item.minecraft.cooked_rabbit": "brotna hos",
  "item.minecraft.rabbit_stew": "hosnragout",
  "item.minecraft.rabbit_foot": "hosnpfotn",
  "item.minecraft.rabbit_hide": "hosnfö",
  "item.minecraft.armor_stand": "rüstungsstända",
  "item.minecraft.iron_horse_armor": "roßrüstung aus eisn",
  "item.minecraft.golden_horse_armor": "roßrüstung aus goid",
  "item.minecraft.diamond_horse_armor": "roßrüstung aus diamant",
  "item.minecraft.leather_horse_armor": "roßrüstung aus leda",
  "item.minecraft.lead": "leine",
  "item.minecraft.name_tag": "nomnsschüd",
  "item.minecraft.command_block_minecart": "wagon mit befehlsblock",
  "item.minecraft.mutton": "ruachs hommefleisch",
  "item.minecraft.cooked_mutton": "brotns hommefleisch",
  "block.minecraft.white_banner": "weißs banna",
  "block.minecraft.orange_banner": "orangs banna",
  "block.minecraft.magenta_banner": "magentas banna",
  "block.minecraft.light_blue_banner": "hellblaus banna",
  "block.minecraft.yellow_banner": "gelbs banna",
  "block.minecraft.lime_banner": "hellgrüns banna",
  "block.minecraft.pink_banner": "rosas banna",
  "block.minecraft.gray_banner": "graus banna",
  "block.minecraft.light_gray_banner": "hellgraus banna",
  "block.minecraft.cyan_banner": "türkises banna",
  "block.minecraft.purple_banner": "lilas banna",
  "block.minecraft.blue_banner": "blaus banna",
  "block.minecraft.brown_banner": "brauns banna",
  "block.minecraft.green_banner": "grüns banna",
  "block.minecraft.red_banner": "rots banna",
  "block.minecraft.black_banner": "schworzs banna",
  "item.minecraft.end_crystal": "enderkristall",
  "item.minecraft.chorus_fruit": "chorusfrucht",
  "item.minecraft.popped_chorus_fruit": "platzte chorusfrucht",
  "item.minecraft.beetroot": "rote bete",
  "item.minecraft.beetroot_seeds": "rote-bete-somen",
  "item.minecraft.beetroot_soup": "borschtsch",
  "item.minecraft.dragon_breath": "drochnatem",
  "item.minecraft.splash_potion": "ned braubora wurftronk□wirkungslos",
  "item.minecraft.spectral_arrow": "spektralpfeil",
  "item.minecraft.tipped_arrow": "ned heastöhbora getränkta pfeil□wirkungslos",
  "item.minecraft.lingering_potion": "ned braubora vaweiltronk□wirkungslos",
  "item.minecraft.shield": "schüd",
  "item.minecraft.elytra": "elytren",
  "item.minecraft.spruce_boat": "fichtnhoizboot",
  "item.minecraft.birch_boat": "birknhoizboot",
  "item.minecraft.jungle_boat": "tropnhoizboot",
  "item.minecraft.acacia_boat": "akazienhoizboot",
  "item.minecraft.dark_oak_boat": "schworzoachnhoizboot",
  "item.minecraft.totem_of_undying": "totem dea unsterblichkeit",
  "item.minecraft.shulker_shell": "shulkerschö",
  "item.minecraft.iron_nugget": "eisnklumpn",
  "item.minecraft.knowledge_book": "buach des wissns",
  "item.minecraft.debug_stick": "debug-stab",
  "item.minecraft.music_disc_13": "schoiplottn□c418 - 13",
  "item.minecraft.music_disc_cat": "schoiplottn□c418 - cat",
  "item.minecraft.music_disc_blocks": "schoiplottn□c418 - blocks",
  "item.minecraft.music_disc_chirp": "schoiplottn□c418 - chirp",
  "item.minecraft.music_disc_far": "schoiplottn□c418 - far",
  "item.minecraft.music_disc_mall": "schoiplottn□c418 - mall",
  "item.minecraft.music_disc_mellohi": "schoiplottn□c418 - mellohi",
  "item.minecraft.music_disc_stal": "schoiplottn□c418 - stal",
  "item.minecraft.music_disc_strad": "schoiplottn□c418 - strad",
  "item.minecraft.music_disc_ward": "schoiplottn□c418 - ward",
  "item.minecraft.music_disc_11": "schoiplottn□c418 - 11",
  "item.minecraft.music_disc_wait": "schoiplottn□c418 - wait",
  "item.minecraft.music_disc_pigstep": "schoiplottn□lena raine - pigstep",
  "item.minecraft.trident": "dreizock□□in da haupthond:□+8 ongriffsschodn□-2.9 ongriffsgschwindigkeit",
  "item.minecraft.phantom_membrane": "phantomhaut",
  "item.minecraft.nautilus_shell": "natilusschö",
  "item.minecraft.heart_of_the_sea": "herz des meeres",
  "item.minecraft.crossbow": "oambrust",
  "item.minecraft.suspicious_stew": "vadächtige suppn",
  "block.minecraft.loom": "webstui",
  "item.minecraft.flower_banner_pattern": "bannamusta□blume",
  "item.minecraft.creeper_banner_pattern": "bannamusta□creeper",
  "item.minecraft.skull_banner_pattern": "bannamusta□schädl",
  "item.minecraft.mojang_banner_pattern": "bannamusta□mojang-logo",
  "item.minecraft.globe_banner_pattern": "bannamusta□globus",
  "item.minecraft.piglin_banner_pattern": "bannamusta□schnauzn",
  "block.minecraft.composter": "komposta",
  "block.minecraft.barrel": "foss",
  "block.minecraft.smoker": "räucherofn",
  "block.minecraft.blast_furnace": "schmözofn",
  "block.minecraft.cartography_table": "kartntisch",
  "block.minecraft.fletching_table": "bognatisch",
  "block.minecraft.grindstone": "schleifstoa",
  "block.minecraft.lectern": "lesepuit",
  "block.minecraft.smithing_table": "schmiedtisch",
  "block.minecraft.stonecutter": "stoasog",
  "block.minecraft.bell": "glockn",
  "block.minecraft.lantern": "latern",
  "block.minecraft.soul_lantern": "seelenlatern",
  "item.minecraft.sweet_berries": "süßbeern",
  "block.minecraft.campfire": "logafeia",
  "block.minecraft.soul_campfire": "seelnlogerfeuer",
  "block.minecraft.shroomlight": "pilzlicht",
  "item.minecraft.honeycomb": "honigwobn",
  "block.minecraft.bee_nest": "bienennest",
  "block.minecraft.beehive": "bienenstock",
  "item.minecraft.honey_bottle": "honigfloschn",
  "block.minecraft.honey_block": "honigblock",
  "block.minecraft.honeycomb_block": "honigwobnblock",
  "block.minecraft.lodestone": "leitstoa",
  "block.minecraft.netherite_block": "netheritblock",
  "block.minecraft.ancient_debris": "antika schrott",
  "block.minecraft.target": "züscheibnblock",
  "block.minecraft.crying_obsidian": "weinender obsidian",
  "block.minecraft.blackstone": "schworzstoa",
  "block.minecraft.blackstone_slab": "schworzstoastufn",
  "block.minecraft.blackstone_stairs": "schworzstoatreppn",
  "block.minecraft.gilded_blackstone": "golddurchzogena schworzstoa",
  "block.minecraft.polished_blackstone": "poliata schworzstoa",
  "block.minecraft.polished_blackstone_slab": "poliate schworzstoastufn",
  "block.minecraft.polished_blackstone_stairs": "poliate schworzstoatreppn",
  "block.minecraft.chiseled_polished_blackstone": "gmoaßlta poliata schworzstoa",
  "block.minecraft.polished_blackstone_bricks": "poliata schworzstoaziagl",
  "block.minecraft.polished_blackstone_brick_slab": "poliate schworzstoaziaglstufn",
  "block.minecraft.polished_blackstone_brick_stairs": "poliate schworzstoaziagltreppn",
  "block.minecraft.cracked_polished_blackstone_bricks": "rissige poliate schworzstoaziagl",
  "block.minecraft.respawn_anchor": "wiedereinstiegsanker",
}
export const de_at = items; 
